<div class="dialogContent calcHeight content">
  <irb-settings-dialog-banner
    [accordian]="accordian"
    [showUnsavedChangesWarning]="showUnsavedChangesWarning"
    [isModified]="isModified"
    [validationErrorTemplates]="validationErrorTemplates"
  (save)="saveAllModels()">Models</irb-settings-dialog-banner>
  <div class="body">
    <mat-accordion #accordian="matAccordion" [multi]="true">

      @if (globalSettings) {
        @if (ENABLE_SETTINGS_HIST) {
          <mat-expansion-panel [expanded]="false" (opened)="iss.updateExpansionState('HISTORY','opened')" (closed)="iss.updateExpansionState('HISTORY','closed')">
              <mat-expansion-panel-header>
                  <mat-panel-title>
                      Settings History
                  </mat-panel-title>
              </mat-expansion-panel-header>
              <ng-template matExpansionPanelContent>
                  <irb-settings-history tabName="Models"></irb-settings-history>
              </ng-template>
          </mat-expansion-panel>
        }
        <mat-expansion-panel id="REBALANCE_BANDS"
          [expanded]="iss.getDefaultExpansionState('REBALANCE_BANDS')"
          (opened)="iss.updateExpansionState('REBALANCE_BANDS','opened')"
          (closed)="iss.updateExpansionState('REBALANCE_BANDS','closed')">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Rebalance Bands
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <div class="block">
              <div class="block">
                The rebalance bands determine when a security is outside of the specified accepted range and requires correction...
                <a calltoaction [calltoactionTemplate]="modelRebalancingTemplate">more</a>
                <div>
                  <span class="bold" style="width: 50px; display: inline-block;">Min %</span>
                  <div style="margin: 0 10px; width: 118px; display: inline-block; white-space: nowrap;">Min % = Target % -</div>
                  <irb-number-text-box [disabled]="!isadmin" #autoToleranceMinPerc
                    [(value)]="globalSettings.autoToleranceMinPerc" min="0" max="100"
                    invalidRangeMessage="The value entered is not valid."
                    (change)="onInputChange()" width="50px"></irb-number-text-box><span style="margin: 0 10px;">of Target %.</span>
                    <span class="note"><a style="font-size: 13px" calltoaction [calltoactionTemplate]="exampleForMin" [calltoactionPosition]="'right'">Example</a></span>
                    <ng-template #exampleForMin>
                      If the model target for a security is 10% and the min rebalancing band is set to 20%, the calculated
                      min band will be 8%. The security will be considered out of band and requiring correction when it is
                      below 8%.
                    </ng-template>
                  </div>
                </div>
                <div class="dblock">
                  <div>
                    <span class="bold" style="width: 50px; display: inline-block;">Max %</span>
                    <div style="margin: 0 10px; width: 118px; display: inline-block; white-space: nowrap;">Max % = Target % +</div>
                    <irb-number-text-box [disabled]="!isadmin" #autoToleranceMaxPerc
                      [(value)]="globalSettings.autoToleranceMaxPerc" min="0" max="100"
                      invalidRangeMessage="The value entered is not valid."
                      (change)="onInputChange()" width="50px"></irb-number-text-box><span style="margin: 0 10px;">of Target %.</span>
                      <span class="note"><a [disabled]="!isadmin" style="font-size: 13px" calltoaction [calltoactionTemplate]="exampleForMax" [calltoactionPosition]="'right'">Example</a></span>
                      <ng-template #exampleForMax>
                        If the model target for a security is 10% and the max rebalancing band is set to 20%, the calculated
                        max band will be 12%. The security will be considered out of band and requiring correction when it is
                        above 12%.
                      </ng-template>
                    </div>
                  </div>
                  <div>
                    <div>
                      <div class="left">
                        <span style="font-weight: bold;">How to apply rebalance band settings:</span>
                        <span class="infoIcon" calltoaction
                        [calltoactionTemplate]="rebalanceBandTemplate">&nbsp;</span>
                      </div>
                      <div class="left" style="margin-left: 10px;">
                        <irb-dropdown-filter #IrbAutoToleranceDropDown [disabled]="!isadmin"
                          [(value)]="autoToleranceSetting" (search)="setAutoToleranceDropDown($event)"
                          size="62" hoverPanelWidth="475"
                        (valueChange)="onAutoRebalance()"></irb-dropdown-filter>
                      </div>
                      <br class="clear"/>
                    </div>
                  </div>
                </div>
              </ng-template>
            </mat-expansion-panel>
          }

          @if (globalSettings) {
            <mat-expansion-panel id="REBAL_ACCURACY_RANGE"
              [expanded]="iss.getDefaultExpansionState('REBAL_ACCURACY_RANGE')"
              (opened)="iss.updateExpansionState('REBAL_ACCURACY_RANGE','opened')"
              (closed)="iss.updateExpansionState('REBAL_ACCURACY_RANGE','closed')">
              <mat-expansion-panel-header>
                <mat-panel-title>
                @if(ENABLE_CASH_ACCURACY) {
                  Accuracy Ranges
                } @else {
                  Rebalance Accuracy Range
                }
                </mat-panel-title>
              </mat-expansion-panel-header>
              <ng-template matExpansionPanelContent>
                @if(ENABLE_CASH_ACCURACY) {
                <div class="block">
                  <span>
                    The Accuracy Ranges determine the acceptable range around a security's target allocation after iRebal generates potential trades during a Cash management or Full Rebalance analysis. Accuracy Ranges are expressed as a percentage of the distance between the security's target allocation and its Min/Max rebalancing band values.
                  </span>
                  <span>
                    <span class="note"><a style="font-size: 13px" calltoaction [calltoactionTemplate]="exampleForCA" [calltoactionPosition]="'bottom'" [calltoactionMaxWidth]="'420px'">Example</a></span>
                    <ng-template #exampleForCA>
                          If a security has a <b>10% Target</b> allocation, <b>Min</b> of <b>8%</b>, and <b>Max</b> of <b>12%</b>:
                          <ul>
                            <li>A <b>25% Cash Accuracy Range</b> cannot sell the security below <b>9.5%</b> when generating cash or buy the security above <b>10.5%</b> when investing cash.</li>
                            <li>A <b>50% Rebalancing Accuracy Range</b> must keep the security within <b>9% to 11%</b> when traded during rebalancing.</li>
                          </ul>
                          <b>Note:</b>  A low <b>Rebalance Accuracy Range</b> value keeps allocations closer to target, but may require additional trades of securities that were not out-of-range in order to complete.
                    </ng-template>
                  </span>
                </div>
                }
                @if(ENABLE_CASH_ACCURACY) {
                <div class="block">
                  <span>
                    <span class="bold" style="display: inline-block;">Cash Accuracy Range </span>
                    <span class="infoIcon" calltoaction
                    [calltoactionTemplate]="cashAccuracyRangeTemplate">&nbsp;</span>
                    <span style="margin-right: 10px;">can adjust within <irb-number-text-box [disabled]="!isadmin"
                      #cashTradeCorrectionRangePerc
                      [(value)]="globalSettings.cashTradeCorrectionRangePerc"
                      places="2" min="0" max="100"
                      invalidMessage="Please enter only numbers, with up to two decimal places."
                      invalidRangeMessage="Please enter only numbers between 0 and 100."
                      (change)="onInputChange()"
                    width="50px"></irb-number-text-box> % of the difference between target and min/max band when investing or generating cash.</span>
                  </span>
                </div>
                }
                <div class="block">
                  <span>
                    <span class="bold" style="display: inline-block;">Rebalance Accuracy Range </span>
                    <span class="infoIcon" calltoaction
                    [calltoactionTemplate]="rebalanceAccuracyRangeTemplate">&nbsp;</span>
                    <span style="margin-right: 10px;">can adjust within <irb-number-text-box [disabled]="!isadmin"
                      #securityTradeCorrectionRangePerc
                      [(value)]="globalSettings.securityTradeCorrectionRangePerc"
                      places="2" min="0" max="100"
                      invalidMessage="Please enter only numbers, with up to two decimal places."
                      invalidRangeMessage="Please enter only numbers between 0 and 100."
                      (change)="onInputChange()"
                    width="50px"></irb-number-text-box> % of the difference between target and min/max band when rebalancing.</span>
                  </span>
                </div>
              </ng-template>
            </mat-expansion-panel>
          }
        </mat-accordion>
      </div>
    </div>
    <ng-template #rebalanceBandTemplate>
      <p>How should the rebalance band values in existing models be updated with the new values specified above?<br/>
      Note: Blended model bands will always reflect weighted values of their component models.</p>
    </ng-template>
    <ng-template #rebalanceAccuracyRangeTemplate>
      Rebalance Accuracy Range is used when a security's allocation is outside its Rebalance Band and requires correction during a Full Rebalance.
    </ng-template>
    <ng-template #cashAccuracyRangeTemplate>
      Cash Accuracy Range is used when a security is traded for the purpose of generating cash or investing cash. iRebal may sell a security to its lower accuracy when generating cash or buy a security to the upper accuracy when investing cash.
    </ng-template>
    <ng-template #modelRebalancingTemplate>
      The rebalance bands determine when a security is outside of the specified accepted range and requires correction. The rebalance band settings you specify here will be considered in relation to the model target. You can override them directly in any model.
    </ng-template>
